"use strict";
exports.__esModule = true;
exports.isValidZipCode = void 0;
var zip_1 = require("./zip");
var isValidZipCode = function (zipCode) {
    /**
     * Checks for a valid zip code in the offline Lithic zip code database
     *
     * @param zipCode Zip code as string, max 5 characters
     */
    return zip_1.ZIPCODES.has(zipCode);
};
exports.isValidZipCode = isValidZipCode;
